import React, { useState, useEffect } from 'react';
import './HomeBannerSlider.scss';

function HomeBannerSlider({ items }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [progress, setProgress] = useState(0); 
    const [isPaused, setIsPaused] = useState(false);

    const SLIDE_DURATION = 4000; 

    const nextSlide = () => {
        setCurrentIndex((prevIndex) => 
            prevIndex === items.length - 1 ? 0 : prevIndex + 1
        );
        setProgress(0); 
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => 
            prevIndex === 0 ? items.length - 1 : prevIndex - 1
        );
        setProgress(0); 
    };

    useEffect(() => {
        if (!isPaused) {
            const slideTimer = setInterval(() => {
                nextSlide();
            }, SLIDE_DURATION);

            const progressTimer = setInterval(() => {
                setProgress((prev) => (prev < 100 ? prev + (100 / (SLIDE_DURATION / 10)) : 100));
            }, 10);

            return () => {
                clearInterval(slideTimer);
                clearInterval(progressTimer);
            };
        }
    }, [currentIndex, isPaused]);

    return (
        <div 
            className="home-banner-slider-wrapper"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
        >
            <div className="slider-main">
                
                {/* 🔥 LARGE PURPLE ARROW - LEFT */}
                <button className="slider-arrow prev-arrow" onClick={prevSlide}>
                    &#10094; {/* Unicode character for ❮ */}
                </button>

                {/* THE IMAGE */}
                <img 
                    src={items[currentIndex].imageSrc} 
                    alt={items[currentIndex].imageAlt} 
                    className="fade-in" 
                />
                
                {/* 🔥 LARGE PURPLE ARROW - RIGHT */}
                <button className="slider-arrow next-arrow" onClick={nextSlide}>
                    &#10095; {/* Unicode character for ❯ */}
                </button>

                {/* The Progress Bar Container */}
                <div className="progress-bar-container">
                    <div 
                        className="progress-bar-fill" 
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>
            </div>

            {/* 🔥 NAV CIRCLES NOW CENTERED BELOW THE IMAGE */}
            <div className="slider-circles-nav">
                {items.map((_, index) => (
                    <span 
                        key={index}
                        className={`nav-circle ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => {
                            setCurrentIndex(index);
                            setProgress(0);
                        }}
                    ></span>
                ))}
            </div>
        </div>
    );
}

export default HomeBannerSlider;